import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class AircraftsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      registration: null,
      engine_1_id: null,
      engine_2_id: null,
      cost_center_crew: null,
      cost_center_manager: null,
      aircraft_model_id: null,
      aircraft_model_version_id: null,
      operation_type_id: null,
      serial_number: null,
      ptbr_code: null,
      ca: null,
      iam: null,
      weight: null,
      hums: 0,
      fdm: 0,
      external_load: 0,
      out_of_service: 0,
      schedule_only: 0,
      logbook: 0,
      logbook_date_open: '',
      logbook_date_closed: '',
      initial_flight_hours: '',
      actual_flight_hours: '',
      initial_landings: '',
      actual_landings: '',
      ground_consumption: null,
      flight_consumption: null,
      fuel_capacity: null,
      aircraft_models_list: [],
      operation_types: [],
      aircraft_model_versions_list: [],
      engines_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    var value = event.target.checked === true ? 1 : 0;
    change[name] = value;
    this.setState(change);
  }
  handleSelectAircraftModelChange(name, event) {
    var change = {};
    var self = this;
    change['aircraft_model_version_id'] = null;
    if(event == null) {
      change[name] = null;
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/aeronave/modelo/versoes/lista/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({aircraft_model_versions_list: responseJson.data});
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        });
      });
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ aircraft_models_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/versoes/lista/'+self.state.aircraft_model_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_model_versions_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tipo/operacoes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ operation_types: responseJson.data });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); });
    }); });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      registration: this.state.registration,
      engine_1_id: this.state.engine_1_id,
      engine_2_id: this.state.engine_2_id,
      cost_center_crew: this.state.cost_center_crew,
      cost_center_manager: this.state.cost_center_manager,
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_version_id: this.state.aircraft_model_version_id,
      operation_type_id: this.state.operation_type_id,
      serial_number: this.state.serial_number,
      ptbr_code: this.state.ptbr_code,
      ca: this.state.ca,
      iam: this.state.iam,
      weight: this.state.weight,
      hums: this.state.hums,
      fdm: this.state.fdm,
      external_load: this.state.external_load,
      out_of_service: this.state.out_of_service,
      schedule_only: this.state.schedule_only,
      logbook: this.state.logbook,
      logbook_date_open: this.state.logbook_date_open,
      logbook_date_closed: this.state.logbook_date_closed,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
      initial_flight_hours: this.state.initial_flight_hours,
      initial_landings: this.state.initial_landings,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success' || responseJson.status === 'warning') {
          var url = '/aeronave/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Aeronaves.AdicionarAeronaves.titulo}</h3>
      <Link to="/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Modelo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.SelecioneModeloAeronave}
                onChange={this.handleSelectAircraftModelChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
                required
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Matricula}:</label>
              <input type="text" name="registration" className="form-control" placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.registration} onChange={this.handleChange.bind(this, 'registration')} required />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="operation_type_id"
                value={this.state.operation_type_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.SelecionarTipoOperacao}
                onChange={this.handleSelectChange.bind(this, 'operation_type_id')}
                options={this.state.operation_types}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.NumeroSerie}:</label>
              <input type="text" name="serial_number" className="form-control" placeholder={this.locale.Aeronaves.AdicionarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.serial_number} onChange={this.handleChange.bind(this, 'serial_number')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.CA}:</label>
              <InputMask value={this.state.ca}  maskChar={null} name="ca" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ca')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.IAM}:</label>
              <InputMask value={this.state.iam}  maskChar={null} name="iam" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'iam')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Peso}:</label>
              <input value={this.state.weight} name="weight" className="form-control" onChange={this.handleChange.bind(this, 'weight')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>Utilizada somente em escala:</label>
              <br/>
              <Toggle
                checked={this.state.schedule_only}
                aria-label="No label tag"
                name="schedule_only"
                onChange={this.handleToggleChange.bind(this, 'schedule_only')}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.CodigoPTBR}:</label>
              <input value={this.state.ptbr_code} name="ptbr_code" className="form-control" onChange={this.handleChange.bind(this, 'ptbr_code')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Versao}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_version_id"
                value={this.state.aircraft_model_version_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.SelecionarVersao}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_version_id')}
                options={this.state.aircraft_model_versions_list}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.Logbook}</label>
              <br/>
              <Toggle checked={this.state.logbook} aria-label='No label tag' name="logbook" onChange={this.handleToggleChange.bind(this, 'logbook')} />
            </div>
          </div>
          <div className="col-md-5">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.DataAberturaLogbook}:</label>
              <br/>
              <InputMask value={this.state.logbook_date_open}  maskChar={null} name="logbook_date_open" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'logbook_date_open')} placeholder={this.locale.general.diaMesAno} required={this.state.logbook === 1 ? true : false} />
            </div>
          </div>
          <div className="col-md-5">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.DataEncerramentoLogbook}:</label>
              <InputMask value={this.state.logbook_date_closed}  maskChar={null} name="logbook_date_closed" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'logbook_date_closed')} placeholder={this.locale.general.diaMesAno} />
            </div>
          </div>
        </div>
        { this.state.logbook === 1 &&
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.HorasIniciais}:</label>
                <input type="text" name="initial_flight_hours" className="form-control" value={this.state.initial_flight_hours} onChange={this.handleChange.bind(this, 'initial_flight_hours')} placeholder="00000:00" required />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.HorasAtuais}:</label>
                <input type="text" name="actual_flight_hours" className="form-control" value={this.state.actual_flight_hours} onChange={this.handleChange.bind(this, 'actual_flight_hours')} placeholder="00000:00" disabled />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.PousosIniciais}:</label>
                <input type="number" value={this.state.initial_landings} name="initial_landings" className="form-control" onChange={this.handleChange.bind(this, 'initial_landings')} placeholder="0" required />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.PousosAtuais}:</label>
                <input type="number" value={this.state.actual_landings} name="actual_landings" className="form-control" onChange={this.handleChange.bind(this, 'actual_landings')} placeholder="0" disabled />
              </div>
            </div>
          </div>
        }
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Engine #1:</label>
              <Select className="form-field-name" name="engine_1_id" value={this.state.engine_1_id} searchable={true} placeholder='Select' onChange={this.handleSelectChange.bind(this, 'engine_1_id')} options={this.state.engines_list} required={this.state.logbook === 1 ? true : false} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Engine #2:</label>
              <Select className="form-field-name" name="engine_2_id" value={this.state.engine_2_id} searchable={true} placeholder='Select' onChange={this.handleSelectChange.bind(this, 'engine_2_id')} options={this.state.engines_list} required={this.state.logbook === 1 ? true : false} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Aeronaves.AdicionarAeronaves.formulario.botaoAdicionarAeronave}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftsAdd;



// WEBPACK FOOTER //
// ./src/Components/Aircrafts/AircraftsAdd.js